import { RevenueReportTemplateListPage } from "@/features/revenue-report-template/pages/RevenueReportTemplateListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/revenue-report-template/")({
	validateSearch: (search: Record<string, unknown>) => search,
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_report_template.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueReportTemplateListPage,
});
